module.exports = __webpack_public_path__ + "img/cloud1.2db40ce3.png";